export default {
  'apps.title': 'Workers',
  'apps.getStarted.title': 'Get started in three steps',
  'apps.step1.title': 'Create a Worker',
  'apps.step1.desc': 'Create a logical container for your AI Worker',
  'apps.step2.title': 'Configure a version',
  'apps.step2.desc': 'Define workflows and configuration for this version',
  'apps.step3.title': 'Deploy the version',
  'apps.step3.desc': 'Create a running instance of your AI Worker',
  'apps.list.createApp': 'Create Worker',
  'apps.list.columns.apps': 'Worker',
  'apps.list.columns.status': 'Status',
  'apps.list.columns.latestActivity': 'Latest Activity',
  'apps.list.columns.latestVersion': 'Latest Version',
  'apps.list.columns.plan': 'Plan',
  'apps.list.columns.region': 'Region',
  'apps.list.columns.creationTime': 'Creation Time',
  'apps.list.columns.actions': 'Actions',
  'apps.list.column.updatedAt': 'Updated at',
  'apps.list.column.by': 'By',
  'apps.list.status.published': 'Published',
  'apps.list.status.draft': 'Draft',
  'apps.list.action.viewDetail': 'View Detail',
  'apps.list.action.delete': 'Delete',
  'apps.list.delete.title': 'Delete Worker',
  'apps.list.delete.content':
    'Are you sure you want to delete this Worker? This action cannot be undone.',
  'apps.list.delete.success': 'Worker deleted successfully',
  'apps.list.delete.failed': 'Failed to delete Worker',
  'apps.list.error.fetchFailed': 'Failed to fetch Worker list',

  // Worker status（小写，与后端枚举对齐）
  'apps.status.pending': 'Pending',
  'apps.status.undeployed': 'Undeployed',
  'apps.status.deploying': 'Deploying',
  'apps.status.running': 'Running',
  'apps.status.updating': 'Updating',
  'apps.status.terminating': 'Terminating',
  'apps.status.suspended': 'Suspended',
  'apps.status.failed': 'Failed',
  'apps.status.deploy_failed': 'Deploy Failed',

  // Latest activity descriptions（小写，与后端枚举对齐）
  'apps.activity.pending': 'Worker created, pending version creation',
  'apps.activity.undeployed': 'Draft pending publish',
  'apps.activity.deploying': 'Publishing latest version',
  'apps.activity.running': 'Published successfully',
  'apps.activity.updating': 'Publishing latest version',
  'apps.activity.terminating': 'Releasing instance',
  'apps.activity.suspended': 'Instance suspended (insufficient credits)',
  'apps.activity.failed': 'Deployment failed',

  // Worker event enums (latest_event field values)
  'apps.event.APP_CREATED': 'Worker created',
  'apps.event.VERSION_DRAFT_CREATED': 'Version draft created',
  'apps.event.VERSION_PUBLISHING': 'Publishing version',
  'apps.event.VERSION_PUBLISHED': 'Version published',
  'apps.event.VERSION_ROLLING_BACK': 'Rolling back version',
  'apps.event.INSTANCE_RELEASING': 'Releasing instance',
  'apps.event.INSTANCE_RELEASED': 'Instance released',
  'apps.event.DEPLOY_FAILED': 'Deployment failed',
  'apps.event.PUBLISH_FAILED': 'Publish failed',
  'apps.event.RELEASE_FAILED': 'Release failed',

  // Create modal
  'apps.createModal.title': 'Create Worker',
  'apps.createModal.okText.create': 'Create Now',
  'apps.createModal.okText.saving': 'Creating...',
  'apps.createModal.form.name': 'Worker Name',
  'apps.createModal.form.namePlaceholder': 'Please enter Worker name',
  'apps.createModal.form.nameRequired': 'Please enter Worker name',
  'apps.createModal.form.description': 'Worker Description',
  'apps.createModal.form.descriptionPlaceholder':
    'Please enter Worker description',
  'apps.createModal.form.descriptionRequired':
    'Please enter Worker description',
  'apps.createModal.success': 'Worker created successfully',
  'apps.createModal.error.createFailed': 'Failed to create Worker',
  'apps.createModal.error.missingUserInfo':
    'Missing user information, please login again',

  // Detail page
  'apps.detail.back': 'Back to Workers',
  'apps.detail.tabs.overview': 'Overview',
  'apps.detail.tabs.appInfo': 'Worker Info',
  'apps.detail.tabs.versions': 'Version Management',
  'apps.detail.tabs.instances': 'Instance Management',
  'apps.detail.tabs.dashboard': 'Dashboard',
  'apps.detail.tabs.logs': 'Workflow Logs',
  'apps.detail.tabs.monitor': 'Monitor',
  'apps.detail.monitor.filters.timeRange': 'Time Range',
  'apps.detail.monitor.filters.replica': 'Replica',
  'apps.detail.monitor.filters.allReplicas': 'All Replicas',
  'apps.detail.monitor.filters.granularity': 'Granularity',
  'apps.detail.monitor.timeRange.1h': 'Last 1 Hour',
  'apps.detail.monitor.timeRange.6h': 'Last 6 Hours',
  'apps.detail.monitor.timeRange.1d': 'Last 1 Day',
  'apps.detail.monitor.timeRange.7d': 'Last 7 Days',
  'apps.detail.monitor.timeRange.30d': 'Last 30 Days',
  'apps.detail.monitor.granularity.1min': '1 min',
  'apps.detail.monitor.granularity.5min': '5 min',
  'apps.detail.monitor.granularity.15min': '15 min',
  'apps.detail.monitor.granularity.1h': '1 hour',
  'apps.detail.monitor.chart.cpu': 'CPU Usage',
  'apps.detail.monitor.chart.memory': 'Memory Usage',
  'apps.detail.monitor.chart.storage': 'Persistent Storage Usage',
  'apps.detail.monitor.chart.noData': 'No data',
  'apps.detail.monitor.chart.unit.percent': '%',
  'apps.detail.monitor.chart.unit.gb': 'GB',
  'apps.detail.monitor.error.fetchFailed': 'Failed to fetch monitoring data',
  'apps.detail.error.fetchFailed': 'Failed to fetch Worker detail',

  // Overview tab
  'apps.detail.overview.statusCard.title': 'Status & Latest Activity',
  'apps.detail.overview.statusCard.quickAction.createVersion': 'Create Version',
  'apps.detail.overview.statusCard.quickAction.publishVersion':
    'Publish Version',
  'apps.detail.overview.statusCard.quickAction.viewVersionDetail':
    'View Version Detail',
  'apps.detail.overview.statusCard.quickAction.redeploy': 'Redeploy',
  'apps.detail.overview.appInfo.title': 'Worker Info',
  'apps.detail.overview.appInfo.appId': 'Worker ID',
  'apps.detail.overview.appInfo.name': 'Worker Name',
  'apps.detail.overview.appInfo.description': 'Description',
  'apps.detail.overview.instanceInfo.title': 'Instance Info',
  'apps.detail.overview.instanceInfo.worker': 'Worker Instance',
  'apps.detail.overview.instanceInfo.storage': 'Persistent Storage',
  'apps.detail.overview.instanceInfo.instanceId': 'Instance ID',
  'apps.detail.overview.instanceInfo.instanceName': 'Instance Name',
  'apps.detail.overview.instanceInfo.region': 'Region',
  'apps.detail.overview.instanceInfo.plan': 'Plan',
  'apps.detail.overview.instanceInfo.replicas': 'Replicas',
  'apps.detail.overview.instanceInfo.uptime': 'Uptime',
  'apps.detail.overview.instanceInfo.storageId': 'Storage ID',
  'apps.detail.overview.instanceInfo.storagePlan': 'Storage Plan',
  'apps.detail.overview.instanceInfo.connectionStatus': 'Connection Status',
  'apps.detail.overview.instanceInfo.connected': 'Connected',
  'apps.detail.overview.instanceInfo.disconnected': 'Disconnected',
  'apps.detail.overview.instanceInfo.notConfigured': 'Not Configured',
  'apps.detail.overview.noInstance': 'No instance deployed yet.',

  // Worker info tab
  'apps.detail.appInfo.title': 'Worker Information',
  'apps.detail.appInfo.appId': 'Worker ID',
  'apps.detail.appInfo.name': 'Worker Name',
  'apps.detail.appInfo.description': 'Description',
  'apps.detail.appInfo.status': 'Worker Status',
  'apps.detail.appInfo.endpoint': 'Endpoint URL',
  'apps.detail.appInfo.endpointPlaceholder': 'Available after deployment',
  'apps.detail.appInfo.copy': 'Copy',
  'apps.detail.appInfo.copied': 'Copied',
  'apps.detail.appInfo.sampleCode.title': 'Sample Code',
  'apps.detail.appInfo.sampleCode.copy': 'Copy',
  'apps.detail.appInfo.sampleCode.copied': 'Copied',
  'apps.detail.appInfo.sampleCode.selectWorkflow': 'Select Workflow',
  'apps.detail.appInfo.sampleCode.selectWorkflowPlaceholder':
    'Select a workflow to view sample code',
  'apps.detail.appInfo.sampleCode.byIdentifier': 'By Identifier',
  'apps.detail.appInfo.sampleCode.byWorkflow': 'By Workflow UUID',
  'apps.detail.appInfo.sampleCode.noActiveVersion':
    'No active version. Deploy a version to view sample code.',
  'apps.detail.appInfo.sampleCode.noWorkflows':
    'No workflows found in the active version.',
  'apps.detail.appInfo.sampleCode.loadFailed': 'Failed to load sample code',
  'apps.detail.appInfo.edit': 'Edit',
  'apps.detail.appInfo.save': 'Save',
  'apps.detail.appInfo.cancel': 'Cancel',
  'apps.detail.appInfo.updateSuccess': 'Updated successfully',
  'apps.detail.appInfo.updateFailed': 'Failed to update',
  'apps.detail.appInfo.currentVersion.title': 'Current Active Version',
  'apps.detail.appInfo.currentVersion.noActive': 'No active version',
  'apps.detail.appInfo.currentVersion.version': 'Version',
  'apps.detail.appInfo.currentVersion.description': 'Description',
  'apps.detail.appInfo.currentVersion.workflows': 'Workflow Collection',
  'apps.detail.appInfo.currentVersion.workflowName': 'Workflow Name',
  'apps.detail.appInfo.currentVersion.workflowVersion': 'Version',
  'apps.detail.appInfo.currentVersion.identifier': 'Identifier',
  'apps.detail.appInfo.apiKeys.title': 'Worker API Keys',
  'apps.detail.appInfo.apiKeys.create': 'Create API Key',
  'apps.detail.appInfo.apiKeys.columns.name': 'Key Name',
  'apps.detail.appInfo.apiKeys.columns.key': 'API Key',
  'apps.detail.appInfo.apiKeys.columns.createdAt': 'Created At',
  'apps.detail.appInfo.apiKeys.columns.actions': 'Actions',
  'apps.detail.appInfo.apiKeys.action.copy': 'Copy',
  'apps.detail.appInfo.apiKeys.action.edit': 'Rename',
  'apps.detail.appInfo.apiKeys.action.delete': 'Delete',
  'apps.detail.appInfo.apiKeys.delete.title': 'Delete API Key',
  'apps.detail.appInfo.apiKeys.delete.content':
    'Are you sure you want to delete this API key? This action cannot be undone.',
  'apps.detail.appInfo.apiKeys.createSuccess': 'API key created',
  'apps.detail.appInfo.apiKeys.created.title': 'API Key Created',
  'apps.detail.appInfo.apiKeys.created.warning':
    'Please copy and save your API key now. For security reasons, it will only be shown once and cannot be retrieved after you close this dialog.',
  'apps.detail.appInfo.apiKeys.created.copy': 'Copy API Key',
  'apps.detail.appInfo.apiKeys.created.copied': 'Copied',
  'apps.detail.appInfo.apiKeys.created.confirm': 'I have saved it, close',
  'apps.detail.appInfo.apiKeys.deleteSuccess': 'API key deleted',
  'apps.detail.appInfo.apiKeys.editSuccess': 'API key renamed',
  'apps.detail.appInfo.apiKeys.error.fetchFailed': 'Failed to fetch API keys',

  // Version tab
  'apps.detail.versions.createVersion': 'Create Version',
  'apps.detail.versions.columns.version': 'Version',
  'apps.detail.versions.columns.changelog': 'Release Notes',
  'apps.detail.versions.columns.status': 'Status',
  'apps.detail.versions.columns.workflowCount': 'Workflows',
  'apps.detail.versions.columns.createdBy': 'Created By',
  'apps.detail.versions.columns.createdAt': 'Created At',
  'apps.detail.versions.columns.actions': 'Actions',
  'apps.detail.versions.action.detail': 'Detail',
  'apps.detail.versions.action.edit': 'Edit',
  'apps.detail.versions.action.delete': 'Delete',
  'apps.detail.versions.action.rollback': 'Rollback',
  'apps.detail.versions.action.publish': 'Publish',
  'apps.detail.versions.delete.title': 'Delete Version',
  'apps.detail.versions.delete.content':
    'Are you sure you want to delete this version?',
  'apps.detail.versions.deleteSuccess': 'Version deleted',
  'apps.detail.versions.error.fetchFailed': 'Failed to fetch versions',
  'apps.detail.versions.noVersionToPublish':
    'No version available to publish. Please create a version first.',
  'apps.detail.versions.detail.title': 'Version Detail',
  'apps.detail.versions.detail.loadFailed': 'Failed to load version detail',
  'apps.detail.versions.detail.changelog': 'Changelog',
  'apps.detail.versions.detail.createdBy': 'Created By',
  'apps.detail.versions.detail.publishedBy': 'Published By',
  'apps.detail.versions.detail.createdAt': 'Created At',
  'apps.detail.versions.detail.updatedAt': 'Updated At',
  'apps.detail.versions.detail.workflowEntries': 'Workflow Entries',
  'apps.detail.versions.detail.identifier': 'Identifier',
  'apps.detail.versions.detail.workflowUuid': 'Workflow UUID',
  'apps.detail.versions.detail.workflowName': 'Workflow Name',
  'apps.detail.versions.detail.publishVersion': 'Version',

  // Version status（小写，与后端枚举对齐）
  'apps.version.status.draft': 'Draft',
  'apps.version.status.publishing': 'Publishing',
  'apps.version.status.active': 'Active',
  'apps.version.status.archived': 'Archived',

  // Instance tab
  'apps.detail.instances.title': 'Instance Management',
  'apps.detail.instances.action.release': 'Release Instance',
  'apps.detail.instances.action.restart': 'Restart Instance',
  'apps.detail.instances.action.scale': 'Manual Scale',
  'apps.detail.instances.action.changePlan': 'Change Plan',
  'apps.detail.instances.worker.title': 'Worker Instance',
  'apps.detail.instances.worker.instanceId': 'Instance ID',
  'apps.detail.instances.worker.instanceName': 'Instance Name',
  'apps.detail.instances.worker.region': 'Region',
  'apps.detail.instances.worker.plan': 'Plan',
  'apps.detail.instances.worker.replicas': 'Replicas',
  'apps.detail.instances.worker.uptime': 'Uptime',
  'apps.detail.instances.storage.title': 'Persistent Storage',
  'apps.detail.instances.storage.instanceId': 'Storage ID',
  'apps.detail.instances.storage.plan': 'Plan',
  'apps.detail.instances.storage.spec': 'Storage Plan',
  'apps.detail.instances.storage.connectionStatus': 'Connection Status',
  'apps.detail.instances.storage.status': 'Connection Status',
  'apps.detail.instances.storage.connected': 'Connected',
  'apps.detail.instances.storage.disconnected': 'Disconnected',
  'apps.detail.instances.storage.notConfigured': 'Not Configured',
  'apps.detail.instances.replicas.title': 'Replica List',
  'apps.detail.instances.replicas.refresh': 'Refresh',
  'apps.detail.instances.replicas.columns.replicaId': 'Replica ID',
  'apps.detail.instances.replicas.columns.status': 'Status',
  'apps.detail.instances.replicas.columns.startTime': 'Start Time',
  'apps.detail.instances.replicas.columns.cpu': 'CPU',
  'apps.detail.instances.replicas.columns.memory': 'Memory',
  'apps.detail.instances.replicas.columns.actions': 'Actions',
  'apps.detail.instances.replicas.action.restart': 'Restart',
  'apps.detail.instances.release.title': 'Release Instance',
  'apps.detail.instances.release.content':
    'Are you sure you want to release this instance? The Worker will stop serving.',
  'apps.detail.instances.scale.title': 'Manual Scale',
  'apps.detail.instances.scale.label': 'Replica Count',
  'apps.detail.instances.scale.success': 'Scaled successfully',
  'apps.detail.instances.noInstance': 'No instance deployed.',

  // Dashboard tab
  'apps.detail.dashboard.timeRange.1h': 'Last 1h',
  'apps.detail.dashboard.timeRange.6h': 'Last 6h',
  'apps.detail.dashboard.timeRange.1d': 'Last 1d',
  'apps.detail.dashboard.timeRange.7d': 'Last 7d',
  'apps.detail.dashboard.timeRange.30d': 'Last 30d',
  'apps.detail.dashboard.workflow': 'Workflow',
  'apps.detail.dashboard.allWorkflows': 'All Workflows',
  'apps.detail.dashboard.cumulative.workflows': 'Total Workflows',
  'apps.detail.dashboard.cumulative.requests': 'Total Requests',
  'apps.detail.dashboard.cumulative.tokens': 'LLM Tokens',
  'apps.detail.dashboard.chart.requests': 'Requests',
  'apps.detail.dashboard.chart.errorRate': 'Error Rate',
  'apps.detail.dashboard.chart.avgResponseTime': 'Avg Response Time',
  'apps.detail.dashboard.chart.p90p99': 'P90 / P99',
  'apps.detail.dashboard.chart.tokens': 'Token Usage',
  'apps.detail.dashboard.chart.time': 'Time',
  'apps.detail.dashboard.chart.count': 'Count',
  'apps.detail.dashboard.chart.rate': 'Rate (%)',
  'apps.detail.dashboard.chart.ms': 'Time (ms)',
  'apps.detail.dashboard.comingSoon': 'Chart coming soon',

  // Logs tab
  'apps.detail.logs.filter.timeRange': 'Time Range',
  'apps.detail.logs.filter.requestId': 'Request ID',
  'apps.detail.logs.filter.executionId': 'Execution ID',
  'apps.detail.logs.filter.triggerBy': 'Trigger By',
  'apps.detail.logs.filter.search': 'Search',
  'apps.detail.logs.filter.reset': 'Reset',
  'apps.detail.logs.columns.startTime': 'Start Time',
  'apps.detail.logs.columns.result': 'Result',
  'apps.detail.logs.columns.duration': 'Duration',
  'apps.detail.logs.columns.requestId': 'Request ID',
  'apps.detail.logs.columns.executionId': 'Execution ID',
  'apps.detail.logs.columns.tokens': 'Tokens',
  'apps.detail.logs.columns.triggerBy': 'Trigger By',
  'apps.detail.logs.columns.input': 'Input',
  'apps.detail.logs.columns.output': 'Output',
  'apps.detail.logs.columns.actions': 'Actions',
  'apps.detail.logs.action.detail': 'View Detail',
  'apps.detail.logs.result.success': 'Success',
  'apps.detail.logs.result.failed': 'Failed',
  'apps.detail.logs.result.running': 'Running',
  'apps.detail.logs.noStorage.title': 'Persistent log storage not enabled',
  'apps.detail.logs.noStorage.desc':
    'This Worker has not enabled persistent log storage.',
  'apps.detail.logs.noStorage.action': 'Enable Now',
  'apps.detail.logs.error.fetchFailed': 'Failed to fetch logs',

  // Create version modal
  'apps.createVersion.title': 'Create Version',
  'apps.createVersion.editTitle': 'Edit Version',
  'apps.createVersion.updateSuccess': 'Version updated successfully',
  'apps.createVersion.okText': 'Save',
  'apps.createVersion.saving': 'Checking...',
  'apps.createVersion.configRefs.title': 'Confirm Resource References',
  'apps.createVersion.configRefs.summary':
    'This version includes {workflowCount} workflow(s) that require {configCount} configuration(s) to be synchronized. Please verify completeness and confirm authorization for Worker use.',
  'apps.createVersion.configRefs.noConfig':
    'No additional configurations are required for the selected workflows.',
  'apps.createVersion.configRefs.columns.config': 'Configuration',
  'apps.createVersion.configRefs.columns.workflows': 'Associated Workflows',
  'apps.createVersion.configRefs.source.builtin': 'Built-in',
  'apps.createVersion.configRefs.source.external': 'External',
  'apps.createVersion.configRefs.saving': 'Saving...',
  'apps.createVersion.form.version': 'Version Number',
  'apps.createVersion.form.versionPlaceholder': 'e.g. v1.0.0',
  'apps.createVersion.form.versionRequired': 'Please enter version number',
  'apps.createVersion.form.versionFormat':
    'Version must follow format: v{major}.{minor}.{patch}',
  'apps.createVersion.form.changelog': 'Release Notes',
  'apps.createVersion.form.changelogPlaceholder':
    'Describe the changes in this version',
  'apps.createVersion.form.changelogRequired': 'Please enter release notes',
  'apps.createVersion.form.workflows': 'Workflow Collection',
  'apps.createVersion.form.workflowsRequired': 'At least one workflow required',
  'apps.createVersion.workflow.search': 'Search workflows',
  'apps.createVersion.workflow.filterByTag': 'Filter by tag',
  'apps.createVersion.workflow.tagPlaceholder': 'Filter by tag',
  'apps.createVersion.workflow.selectByTag': 'Select All',
  'apps.createVersion.workflow.selectByTagSuccess':
    '{count} workflows with selected tags have been added',
  'apps.createVersion.workflow.selectByTagEmpty':
    'No workflows found with selected tags',
  'apps.createVersion.workflow.applyIdentifiers': 'Apply Workspace Identifiers',
  'apps.createVersion.workflow.applyIdentifiersConfirm':
    'This will auto-select {count} workflows based on current workspace identifiers. Continue?',
  'apps.createVersion.workflow.applyIdentifiersEmpty':
    'No Identifier configuration found in the current workspace',
  'apps.createVersion.workflow.applyIdentifiersTitle':
    'Apply Workspace Identifiers',
  'apps.createVersion.workflow.applyIdentifiersSuccess':
    '{count} workflows auto-selected with matched versions',
  'apps.createVersion.workflow.clear': 'Clear',
  'apps.createVersion.workflow.columns.name': 'Workflow Name',
  'apps.createVersion.workflow.columns.description': 'Description',
  'apps.createVersion.workflow.columns.version': 'Version',
  'apps.createVersion.workflow.columns.identifier': 'Identifier',
  'apps.createVersion.workflow.columns.tags': 'Tags',
  'apps.createVersion.workflow.versionDefault': 'Latest',
  'apps.createVersion.workflow.identifierPlaceholder': 'e.g. workflow_abcd',
  'apps.createVersion.workflow.publishedOnly':
    'Only published workflows in this workspace are available',
  'apps.createVersion.workflow.versionTip':
    'Leave blank to use the latest published version',
  'apps.createVersion.workflow.identifierTip':
    'Leave blank to use system-generated identifier',
  'apps.createVersion.confirmPublish.title': 'Publish Latest Version?',
  'apps.createVersion.confirmPublish.content':
    'Do you want to publish the latest version now?',
  'apps.createVersion.confirmPublish.cancel': 'Later',
  'apps.createVersion.confirmPublish.confirm': 'Publish Now',
  'apps.createVersion.success': 'Version created successfully',
  'apps.createVersion.error.createFailed': 'Failed to create version',
  'apps.createVersion.selectedWorkflows': 'Selected Workflows ({count})',

  // Publish version modal
  'apps.publishVersion.title': 'Publish Version',
  'apps.publishVersion.okText': 'Publish Now',
  'apps.publishVersion.publishing': 'Publishing...',
  'apps.publishVersion.form.region': 'Region',
  'apps.publishVersion.form.plan': 'Instance Plan',
  'apps.publishVersion.form.replicas': 'Replica Count',
  'apps.publishVersion.form.replicasMin': 'Min: 2',
  'apps.publishVersion.form.replicasMax': 'Max: 10',
  'apps.publishVersion.form.instanceName': 'Instance Name (Optional)',
  'apps.publishVersion.form.instanceNamePlaceholder': 'Auto-generated if empty',
  'apps.publishVersion.form.logStorage': 'Log Storage',
  'apps.publishVersion.form.logStorageDesc':
    'When enabled, workflow execution logs on this Worker will be persisted; when disabled, logs cannot be collected.',
  'apps.publishVersion.form.storagePlan': 'Storage Plan',
  'apps.publishVersion.form.storagePlanNote':
    'High-availability setup with 1 primary + 2 replicas (Titan HA). Region follows the Worker instance region.',
  'apps.publishVersion.plan.basic': 'Basic',
  'apps.publishVersion.plan.standard': 'Standard',
  'apps.publishVersion.plan.performance': 'Performance',
  'apps.publishVersion.plan.cpu': '{cpu} Core',
  'apps.publishVersion.plan.memory': '{memory} GB',
  'apps.publishVersion.plan.credits': '{credits} Credits/hr',
  'apps.publishVersion.storage.credits': '{credits} Credits/hr/replica',
  'apps.publishVersion.readonlyTip':
    'Instance is already running. Only full version update is supported.',
  'apps.publishVersion.success': 'Version published successfully',
  'apps.publishVersion.error.publishFailed': 'Failed to publish version',
  'apps.publishVersion.rollbackTitle': 'Rollback Version',
  'apps.publishVersion.rollbackOkText': 'Confirm Rollback',
  'apps.publishVersion.rollbackSuccess': 'Version rolled back successfully',
  'apps.publishVersion.error.rollbackFailed': 'Failed to rollback version',

  // Application messages
  'apps.fileReadFailed':
    'File reading failed, please check the file format and try again',
  'apps.selectFileFirst': 'Please select files to parse first',
  'apps.executeFailed': 'Execution failed, please try again later',
  'apps.fetchOverviewTrendFailed':
    'Failed to fetch overview trend, please try again later',
  'apps.fetchConversationListFailed':
    'Failed to fetch conversation list, please try again later',
  'apps.fetchConversationDetailFailed':
    'Failed to fetch conversation details, please try again later',
  'apps.fetchConversationScoreFailed':
    'Failed to fetch conversation score, please try again later',
};
